import React, {Component} from 'react';
import Styles from './style.css';
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import BoosterHeader from "../../../components/booster-header/component";
import Dropdown from "../../../components/dropdown/component";
import {langRegister} from "../../../services/langRegister";
import {dataRegister} from "../../../services/dataRegister";
import DropdownCurrency from "../../../components/dropdown-currency/component";
import {scraperRegister} from "../../../services/scraperRegister";
import {flowRegister} from "../../../services/flowRegister";
import {collectedRegister} from "../../../services/collectedRegister";
import {salesChannelRegister} from "../../../services/salesChannelRegister";
import DropdownGoogle from "../../../components/dropdown-google/component";
import DropdownRegionNarrow from "../../../components/dropdown-region-narrow/component";
import DropdownAmenities from "../../../components/dropdown-amenities/component";
import DropdownSliderPrice from "../../../components/dropdown-slider-price/component";
import DropdownSliderSize from "../../../components/dropdown-slider-size/component";
import DropdownTabs from "../../../components/dropdown-tabs/component";
import DropdownSliderDuration from "../../../components/dropdown-slider-duration/component";
import {cartRegister} from "../../../services/cartRegister";
import {imagesRegister} from "../../../services/imagesRegister";
import {themeRegister} from "../../../services/themeRegister";
import {videoRegister} from "../../../services/videoRegister";
import {userRegister} from "../../../services/userRegister";
import {tokenRegister} from "../../../services/tokenRegister";


const propertyBoosterDataEn = require("../../../assets/propertybooster-data/en");

const boostaBostadDataEn = require("../../../assets/boostabostad-data/en");
const boostaBostadDataSv = require("../../../assets/boostabostad-data/sv");

const currencies = require("../../../assets/currencies.json");

class BoosterIndustryPropertyBooster extends Component {

    constructor(props) {
        super(props);
        this.state = {
            static_currencies: currencies,
            isLoading: true,
            industries: [],
            images: [],
            website: null,
            platform: null,
            tabs: {
                error: false,
                disabled: false,
                value: {}
            },
            property: {
                options: [],
                placeholder: "Property",
                error: false,
                disabled: true,
                value: "-1"
            },
            currencies: {
                options: [],
                placeholder: "Select currency",
                error: false,
                disabled: false,
                value: "-1"
            },
            types: {
                options: [],
                placeholder: "Select type",
                error: false,
                disabled: false,
                value: "-1"
            },
            beds: {
                options: [],
                placeholder: "Select beds",
                error: false,
                disabled: false,
                value: "-1"
            },
            baths: {
                options: [],
                placeholder: "Select baths",
                error: false,
                disabled: false,
                value: "-1"
            },
            stats: {
                options: [],
                placeholder: "Select status",
                error: false,
                disabled: false,
                value: "-1"
            },
            furnishings: {
                options: [],
                placeholder: "Select furnishing",
                error: false,
                disabled: false,
                value: "-1"
            },
            google: {
                placeholder: "Search..",
                places: [],
                error: false,
                disabled: false,
                value: null
            },
            region: {
                placeholder: "Search..",
                error: false,
                disabled: false,
                places: [],
                grid: {},
                value: null,
                loading: true
            },
            size: {
                caption_sqft: " SQFT",
                caption_sqm: " SQM",
                disabled: false,
                error: false,
                value: 0
            },
            price: {
                caption: "On request",
                disabled: false,
                error: false,
                currency: "",
                value: 0
            },
            durations: {
                caption: "On request",
                options: [],
                error: false,
                disabled: false,
                duration: null,
                value: null
            },
            amenities: {
                options: [],
                error: false,
                disabled: false
            },
            discounts: {
                options: [],
                placeholder: "Select discount",
                error: false,
                disabled: false,
                value: "-1"
            },
            dldwaivers: {
                options: [],
                placeholder: "Select DLD waiver",
                error: false,
                disabled: false,
                value: "-1"
            },
            cheques: {
                options: [],
                placeholder: "Select cheques",
                error: false,
                disabled: false,
                value: "-1"
            },
            freemonths: {
                options: [],
                placeholder: "Select free months",
                error: false,
                disabled: false,
                value: "-1"
            },
            downpayments: {
                options: [],
                placeholder: "Select down payment",
                error: false,
                disabled: false,
                value: "-1"
            },
            finance: {
                options: [],
                placeholder: "Select finance",
                error: false,
                disabled: true,
                value: "-1"
            },
            roi: {
                options: [],
                placeholder: "Select ROI",
                error: false,
                disabled: true,
                value: "-1"
            },
            paymentplan: {
                options: [],
                placeholder: "Select payment plan",
                error: false,
                disabled: false,
                value: "-1"
            },
            servicecharge: {
                options: [],
                placeholder: "Select service charge",
                error: false,
                disabled: false,
                value: "-1"
            },
            contact: {
                name: null,
                profile_image: null,
                logo: null,
                company: null,
                phone: null
            },
            regions_errors: {},
        };
    };

    componentWillMount() {
        window.scrollTo(0, 0);
        this.init.industries();
    };

    componentDidMount() {
        videoRegister.remove();
        try{
            let user = userRegister.get();
            if(user){
                this.setState({
                    inhouse: user.inhouse
                })
            }
            if (user.socialData) {
                this.setState({
                    custom_creative: user.socialData.custom_creatives ? user.socialData.custom_creatives : false,
                    reseller_name: user.socialData.reseller_name ? user.socialData.reseller_name : "",
                    qrcode_ads: user.socialData.qrcode_ads ? user.socialData.qrcode_ads : false,
                });
            }
        }catch (e) {}

        let token = tokenRegister.getToken();
        if(!token){
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang());
        }

    }

    scraper = {
        init: () => {

            let scraper_data = JSON.parse(scraperRegister.get());

            //IMAGES
            try {
                let images = scraper_data.images ? scraper_data.images : [];
                if(images.length > 0){
                    this.init.images(images);
                }
                console.log(images);
            } catch (e) {
                console.log(e);
            }

            //DESCRIPTION
            if (collectedRegister.getValue("description")) {
                this.init.description(collectedRegister.getValue("description"));
            }else{
                try {
                    let description = scraper_data.additional_information.description ? scraper_data.additional_information.description : null;
                    if(description){
                        this.init.description(description);
                    }
                } catch (e) {}
            }

            //DRAFT
            if (collectedRegister.getValue("draft")) {
                this.init.draft(collectedRegister.getValue("draft"));
            }else{
                try {
                    let draft = scraper_data.additional_information.draft ? scraper_data.additional_information.draft : null;
                    if(draft){
                        this.init.draft(draft);
                    }
                } catch (e) {}
            }

            //WEB TOUR
            if (collectedRegister.getValue("web_tour")) {
                this.init.web_tour(collectedRegister.getValue("web_tour"));
            }else{
                try {
                    let web_tour = scraper_data.additional_information.web_tour ? scraper_data.additional_information.web_tour : null;
                    if(web_tour){
                        this.init.web_tour(web_tour);
                    }
                } catch (e) {}
            }

            //WEBSITE
            if (collectedRegister.getValue("website")) {
                this.init.website(collectedRegister.getValue("website"));
            }else{
                try {
                    let website = scraper_data.additional_information.url ? scraper_data.additional_information.url : null;
                    if(website){
                        this.init.website(website);
                    }
                } catch (e) {}
            }

            //CONTACT
            if (collectedRegister.getValue("contact")) {
                this.init.contact(collectedRegister.getValue("contact"));
            }else{
                try {
                    let name = scraper_data.additional_information.broker.name ? scraper_data.additional_information.broker.name : null;
                    let image = scraper_data.additional_information.broker.image ? scraper_data.additional_information.broker.image : null;
                    let company = scraper_data.additional_information.broker.company ? scraper_data.additional_information.broker.company : null;
                    let phone = scraper_data.additional_information.broker.phone ? scraper_data.additional_information.broker.phone : null;
                    let ref = scraper_data.additional_information.broker.ref ? scraper_data.additional_information.broker.ref : null;
                    let permit = scraper_data.additional_information.broker.permit ? scraper_data.additional_information.broker.permit : null;
                    let qrcode = scraper_data.additional_information.broker.qrcode ? scraper_data.additional_information.broker.qrcode : null;
                    let broker = {
                        name: name,
                        profile_image: image,
                        company: company,
                        phone: phone,
                        ref: ref,
                        permit: permit,
                        qrcode: qrcode
                    };
                    this.init.contact(broker);
                } catch (e) {}
            }

            //PROPERTY
            if (collectedRegister.getValue("property")) {
                this.init.website(collectedRegister.getValue("property"));
            }else{
                try {
                    this.init.property({id: 0});
                } catch (e) {}
            }

            //LISTING PLATFORM
            if (collectedRegister.getValue("platform")) {
                this.init.platform(collectedRegister.getValue("platform"));
            }else{
                try {
                    let platform = scraper_data.additional_information.facts.listing_platform ? scraper_data.additional_information.facts.listing_platform : null;
                    this.init.platform(platform);
                } catch (e) {
                    this.init.platform(null);
                }
            }

            //LISTING TYPE
            if (collectedRegister.getValue("listing_type")) {
                this.init.listingType(collectedRegister.getValue("listing_type"));
            } else {
                try {
                    let listing_type = scraper_data.additional_information.facts.listing_type ? scraper_data.additional_information.facts.listing_type : null;
                    this.init.listingType(listing_type);
                } catch (e) {
                    this.init.listingType(null);
                }
            }

            //TYPE
            if (collectedRegister.getValue("type")) {
                this.init.types(JSON.parse(collectedRegister.getValue("type")));
            } else {
                try {
                    let type = scraper_data.additional_information.facts.type ? scraper_data.additional_information.facts.type : null;
                    this.init.types(type);
                } catch (e) {
                    this.init.types(null);
                }
            }

            //BED
            if (collectedRegister.getValue("bed")) {
                this.init.beds(JSON.parse(collectedRegister.getValue("bed")).amount);
            } else {
                try {
                    let bed = scraper_data.additional_information.facts.bedrooms ? scraper_data.additional_information.facts.bedrooms : null;
                    this.init.beds(bed);
                } catch (e) {
                    this.init.beds(null);
                }
            }

            //BATH
            if (collectedRegister.getValue("bath")) {
                this.init.baths(JSON.parse(collectedRegister.getValue("bath")).amount);
            } else {
                try {
                    let bath = scraper_data.additional_information.facts.bathrooms ? scraper_data.additional_information.facts.bathrooms : null;
                    this.init.baths(bath);
                } catch (e) {
                    this.init.baths(null);
                }
            }

            //STATUS
            if (collectedRegister.getValue("status")) {
                this.init.stats(JSON.parse(collectedRegister.getValue("status")));
            } else {
                try {
                    let status = scraper_data.additional_information.facts.completion_status ? scraper_data.additional_information.facts.completion_status : null;
                    this.init.stats(status);
                } catch (e) {
                    this.init.stats(null);
                }
            }

            //FURNISHINGS
            if (collectedRegister.getValue("furnishings")) {
                this.init.furnishings(JSON.parse(collectedRegister.getValue("furnishings")));
            } else {
                try {
                    let furnishing = scraper_data.additional_information.facts.furnishings ? scraper_data.additional_information.facts.furnishings : null;
                    this.init.furnishings(furnishing);
                } catch (e) {
                    this.init.furnishings(null);
                }
            }

            //SIZE
            if (collectedRegister.getValue("size")) {
                this.init.size(collectedRegister.getValue("size"));
            } else {
                try {
                    let size = scraper_data.additional_information.facts.area_sqft ? scraper_data.additional_information.facts.area_sqft : salesChannelRegister.get('size');
                    this.init.size(size);
                } catch (e) {
                    this.init.size(null);
                }
            }

            //PRICE
            if (collectedRegister.getValue("base_currency") && (collectedRegister.getValue("price") !== null && collectedRegister.getValue("price") !== undefined )) {
                this.init.price(collectedRegister.getValue("price"), collectedRegister.getValue("base_currency"));
            } else {
                let currency = salesChannelRegister.get('currency');
                try{
                    let scraper_currency = scraper_data.additional_information.facts.currency ? scraper_data.additional_information.facts.currency : salesChannelRegister.get('currency');
                    if(!scraper_currency || (scraper_currency && !this.state.static_currencies[scraper_currency.toUpperCase()])){
                        currency = salesChannelRegister.get('currency');
                    }else{
                        currency = scraper_currency;
                    }
                }catch(error){}
                try {
                    let price = scraper_data.additional_information.facts.price ? scraper_data.additional_information.facts.price : salesChannelRegister.get('price');
                    if(!(/^-?\d+$/.test(price))){
                        //console.log("hej");
                        price = 0;
                    }
                    console.log(price, +price, currency);
                    this.init.price(price, currency);
                } catch (e) {
                    let price = 0;
                    this.init.price(price, currency);
                }
            }

            //DURATION
            if (collectedRegister.getValue("duration")) {
                this.init.duration(JSON.parse(collectedRegister.getValue("duration")));
            } else {
                try {
                    let duration = scraper_data.additional_information.facts.duration ? scraper_data.additional_information.facts.duration : salesChannelRegister.get('duration');
                    this.init.duration(duration);
                } catch (e) {
                    this.init.duration(null);
                }
            }

            //CURRENCY
            if (collectedRegister.getValue("currency") && collectedRegister.getValue("base_currency")) {
                this.init.currencies(collectedRegister.getValue("base_currency"), JSON.parse(collectedRegister.getValue("currency")).title);
            } else {
                try {
                    let currency = scraper_data.additional_information.facts.currency ? scraper_data.additional_information.facts.currency : salesChannelRegister.get('currency');
                    if(currency && this.state.static_currencies[currency.toUpperCase()]){
                        this.init.currencies(currency, currency);
                    }else{
                        this.init.currencies(salesChannelRegister.get('currency'), salesChannelRegister.get('currency'));
                    }
                } catch (e) {
                    this.init.currencies(salesChannelRegister.get('currency'), salesChannelRegister.get('currency'));
                }
            }

            //REGION
            if (collectedRegister.getValue("display_region") && collectedRegister.getValue("region_grid")) {
                let places = collectedRegister.getValue("places") ? collectedRegister.getValue("places") : [];
                let display_region = collectedRegister.getValue("display_region");
                let region_grid = collectedRegister.getValue("region_grid");
                this.init.region(places, display_region, region_grid);
            } else {
                try {
                    let places = scraper_data.additional_information.facts.places ? scraper_data.additional_information.facts.places : [];
                    let display_region = null;
                    let region_grid = {};
                    this.init.region(places, display_region, region_grid);
                } catch (e) {
                    this.init.region([], null, {});
                }
            }

            //GOOGLE
            if (collectedRegister.getValue("google")) {
                this.init.google(collectedRegister.getValue("google"));
            }

            //AMENITIES
            if (collectedRegister.getValue("amenities")) {
                this.init.amenities(collectedRegister.getValue("amenities"));
            } else {
                try {
                    let amenities = scraper_data.slogans ? scraper_data.slogans : [];
                    this.init.amenities(amenities);
                } catch (e) {
                    this.init.amenities([]);
                }
            }

            //DISCOUNT
            if (collectedRegister.getValue("discount")) {
                this.init.discounts(JSON.parse(collectedRegister.getValue("discount")));
            } else {
                this.init.discounts(null);
            }

            //DLD WAIVER
            if (collectedRegister.getValue("dldwaiver")) {
                this.init.dldwaiver(JSON.parse(collectedRegister.getValue("dldwaiver")));
            } else {
                this.init.dldwaiver(null);
            }

            //CHEQUES
            if (collectedRegister.getValue("cheques")) {
                this.init.cheques(JSON.parse(collectedRegister.getValue("cheques")));
            } else {
                this.init.cheques(null);
            }

            //FREEMOTNHS
            if (collectedRegister.getValue("freemonths")) {
                this.init.freemonths(JSON.parse(collectedRegister.getValue("freemonths")));
            } else {
                this.init.freemonths(null);
            }

            //DOWNPAYMENTS
            if (collectedRegister.getValue("downpayments")) {
                this.init.downpayments(JSON.parse(collectedRegister.getValue("downpayments")));
            } else {
                this.init.downpayments(null);
            }

            //FINANCE
            if (collectedRegister.getValue("finance")) {
                this.init.finance(JSON.parse(collectedRegister.getValue("finance")));
            } else {
                this.init.finance(null);
            }

            //ROI
            if (collectedRegister.getValue("roi")) {
                this.init.roi(JSON.parse(collectedRegister.getValue("roi")));
            } else {
                this.init.roi(null);
            }

            //PAYMENTPLAN
            if (collectedRegister.getValue("paymentplan")) {
                this.init.paymentplan(JSON.parse(collectedRegister.getValue("paymentplan")));
            } else {
                this.init.paymentplan(null);
            }

            //SERVICECHARGE
            if (collectedRegister.getValue("servicecharge")) {
                this.init.servicecharge(JSON.parse(collectedRegister.getValue("servicecharge")));
            } else {
                this.init.servicecharge(null);
            }

            this.setState({
                isLoading: false
            });

        }
    };

    init = {
        industries: () => {
            dataRegister.getIndustries(salesChannelRegister.get("market"), langRegister.lang()).then((response) => {
                let parsed_industries = [];
                for (let i = 0; i < response.length; i++) {
                    if (response[i].saleschannel_owner) {
                        parsed_industries.push(response[i]);
                    }
                }
                console.log(parsed_industries);
                this.setState({industries: parsed_industries}, () => {
                    this.scraper.init();
                });
            }, (error) => {});
        },
        images: (images) => {
            this.setState({
                images: images
            });
        },
        contact: (info) => {
            if(info){
                this.setState({
                    contact: info
                });
            }
        },
        website: (website) => {
            if(website){
                this.setState({
                    website: website
                });
            }
        },
        draft: (draft) => {
            if(draft){
                this.setState({
                    draft: draft
                });
            }
        },
        description: (description) => {
            if(description){
                this.setState({
                    description: description
                });
            }
        },
        web_tour: (web_tour) => {
            if(web_tour){
                this.setState({
                    web_tour: web_tour
                });
            }
        },
        platform: (platform) => {
            if(platform){
                this.setState({
                    platform: platform
                });
            }
        },
        property: (property) => {
            let properties = JSON.parse(JSON.stringify(propertyBoosterDataEn.properties));
            if(property){
                for (let i = 0; i < properties.length; i++) {
                    if (properties[i].id === property.id) {
                        this.state.property.value = JSON.stringify(properties[i]);
                    }
                }
            }
            this.state.property.options = properties;
            this.setState({property: this.state.property});
        },
        listingType: (listing_type) => {
            let listing_types = JSON.parse(JSON.stringify(propertyBoosterDataEn.listing_types));
            if(listing_type){
                for (let i = 0; i < listing_types.length; i++) {
                    if (listing_types[i].id === listing_type.id) {
                        this.state.tabs.value = listing_types[i];
                    }
                }
            }
            if(!this.state.tabs.value.title){
                for (let i = 0; i < listing_types.length; i++) {
                    if (listing_types[i].default) {
                        this.state.tabs.value = listing_types[i];
                        break;
                    }
                }
            }
            this.state.tabs.options = listing_types;
            this.setState({tabs: this.state.tabs});
        },
        currencies: (base, value) => {
            dataRegister.rates(base.toLowerCase()).then((response) => {
                try {
                    for (let key in response.rates) {
                        if (key.toLowerCase() === value.toLowerCase()) {
                            this.state.currencies.value = JSON.stringify({title: key, rate: response.rates[key]});
                        }
                        this.state.currencies.options.push({title: key, rate: response.rates[key]});
                    }
                    this.setState({currencies: this.state.currencies});
                } catch (e) {

                }
            }, (error) => {

            });
        },
        types: (type) => {
            let types = JSON.parse(JSON.stringify(propertyBoosterDataEn.types));
            if(type){
                for (let i = 0; i < types.length; i++) {
                    if (types[i].id === type.id) {
                        this.state.types.value = JSON.stringify(types[i]);
                    }
                }
            }
            this.state.types.options = types;
            this.setState({types: this.state.types});
        },
        beds: (bed) => {
            let beds = JSON.parse(JSON.stringify(propertyBoosterDataEn.beds));
            for (let i = 0; i < beds.length; i++) {
                if (beds[i].amount === +bed && bed !== null) {
                    this.state.beds.value = JSON.stringify(beds[i]);
                }
            }
            this.state.beds.options = beds;
            this.setState({beds: this.state.beds});
        },
        baths: (bath) => {
            let baths = JSON.parse(JSON.stringify(propertyBoosterDataEn.baths));
            if(bath){
                for (let i = 0; i < baths.length; i++) {
                    if (baths[i].amount === +bath) {
                        this.state.baths.value = JSON.stringify(baths[i]);
                    }
                }
            }
            this.state.baths.options = baths;
            this.setState({baths: this.state.baths});
        },
        stats: (status) => {
            let stats = JSON.parse(JSON.stringify(propertyBoosterDataEn.stats));
            if(status){
                for (let i = 0; i < stats.length; i++) {
                    if (stats[i].id === status.id) {
                        this.state.stats.value = JSON.stringify(stats[i]);
                    }
                }
            }
            this.state.stats.options = stats;
            this.setState({stats: this.state.stats});
        },
        furnishings: (furnishing) => {
            let furnishings = JSON.parse(JSON.stringify(propertyBoosterDataEn.furnishings));
            if(furnishing){
                for (let i = 0; i < furnishings.length; i++) {
                    if (furnishings[i].id === furnishing.id) {
                        this.state.furnishings.value = JSON.stringify(furnishings[i]);
                    }
                }
            }
            this.state.furnishings.options = furnishings;
            this.setState({furnishings: this.state.furnishings});
        },
        region: (places, display_region, region_grid) => {
            this.state.region.places = places;
            this.state.region.value = display_region;
            this.state.region.grid = region_grid;
            this.setState({region: this.state.region});
        },
        google: (value) => {
            this.state.google.value = value;
            this.setState({google: this.state.google});
        },
        size: (size) => {
            this.state.size.value = +size ? +size : 0;
            this.setState({size: this.state.size});
        },
        price: (price, currency) => {
            this.state.price.value = price ? price : 0;
            this.state.price.currency = currency;
            this.setState({price: this.state.price});
        },
        duration: (duration) => {
            let durations = JSON.parse(JSON.stringify(propertyBoosterDataEn.durations));
            if(duration){
                for (let i = 0; i < durations.length; i++) {
                    if (durations[i].id === duration.id) {
                        this.state.durations.value = JSON.stringify(durations[i]);
                    }
                }
            }
            if (!this.state.durations.value) {
                this.state.durations.value = JSON.stringify(durations[0]);
            }
            this.state.durations.options = durations;
            this.setState({durations: this.state.durations});
        },
        amenities: (selected) => {
            let amenities = JSON.parse(JSON.stringify(propertyBoosterDataEn.amenities));
            for (let i = 0; i < amenities.length; i++) {
                for (let m = 0; m < selected.length; m++) {
                    if (selected[m].id === amenities[i].id && selected[m].selected) {
                        amenities[i].selected = true;
                    }
                }
            }
            this.state.amenities.options = amenities;
            this.setState({amenities: this.state.amenities});
        },
        discounts: (discount) => {
            let discounts = JSON.parse(JSON.stringify(propertyBoosterDataEn.discounts));
            if(discount){
                for (let i = 0; i < discounts.length; i++) {
                    if (discounts[i].id === discount.id) {
                        this.state.discounts.value = JSON.stringify(discounts[i]);
                    }
                }
            }
            this.state.discounts.options = discounts;
            this.setState({discounts: this.state.discounts});
        },
        dldwaiver: (dldwaiver) => {
            let dldwaivers = JSON.parse(JSON.stringify(propertyBoosterDataEn.dldwaivers));
            if(dldwaiver){
                for (let i = 0; i < dldwaivers.length; i++) {
                    if (dldwaivers[i].id === dldwaiver.id) {
                        this.state.dldwaivers.value = JSON.stringify(dldwaivers[i]);
                    }
                }
            }
            this.state.dldwaivers.options = dldwaivers;
            this.setState({dldwaivers: this.state.dldwaivers});
        },
        cheques: (cheque) => {
            let cheques = JSON.parse(JSON.stringify(propertyBoosterDataEn.cheques));
            if(cheque){
                for (let i = 0; i < cheques.length; i++) {
                    if (cheques[i].id === cheque.id) {
                        this.state.cheques.value = JSON.stringify(cheques[i]);
                    }
                }
            }
            this.state.cheques.options = cheques;
            this.setState({cheques: this.state.cheques});
        },
        freemonths: (freemonth) => {
            let freemonths = JSON.parse(JSON.stringify(propertyBoosterDataEn.freemonths));
            if(freemonth){
                for (let i = 0; i < freemonths.length; i++) {
                    if (freemonths[i].id === freemonth.id) {
                        this.state.freemonths.value = JSON.stringify(freemonths[i]);
                    }
                }
            }
            this.state.freemonths.options = freemonths;
            this.setState({freemonths: this.state.freemonths});
        },
        downpayments: (downpayment) => {
            let downpayments = JSON.parse(JSON.stringify(propertyBoosterDataEn.downpayments));
            if(downpayment){
                for (let i = 0; i < downpayments.length; i++) {
                    if (downpayments[i].id === downpayment.id) {
                        this.state.downpayments.value = JSON.stringify(downpayments[i]);
                    }
                }
            }
            this.state.downpayments.options = downpayments;
            this.setState({downpayments: this.state.downpayments});
        },
        finance: (finances) => {
            let finance = JSON.parse(JSON.stringify(propertyBoosterDataEn.finance));
            if(finances){
                for (let i = 0; i < finance.length; i++) {
                    if (finance[i].id === finances.id) {
                        this.state.finance.value = JSON.stringify(finance[i]);
                    }
                }
            }
            this.state.finance.options = finance;
            this.setState({finance: this.state.finance});
        },
        roi: (rois) => {
            let roi = JSON.parse(JSON.stringify(propertyBoosterDataEn.roi));
            if(rois){
                for (let i = 0; i < roi.length; i++) {
                    if (roi[i].id === rois.id) {
                        this.state.roi.value = JSON.stringify(roi[i]);
                    }
                }
            }
            this.state.roi.options = roi;
            this.setState({roi: this.state.roi});
        },
        paymentplan: (paymentplan) => {
            let paymentplans = JSON.parse(JSON.stringify(propertyBoosterDataEn.paymentplan));
            if(paymentplan){
                for (let i = 0; i < paymentplans.length; i++) {
                    if (paymentplans[i].id === paymentplan.id) {
                        this.state.paymentplan.value = JSON.stringify(paymentplans[i]);
                    }
                }
            }
            this.state.paymentplan.options = paymentplans;
            this.setState({paymentplan: this.state.paymentplan});
        },
        servicecharge: (servicecharge) => {
            let servicecharges = JSON.parse(JSON.stringify(propertyBoosterDataEn.servicecharge));
            if(servicecharge){
                for (let i = 0; i < servicecharges.length; i++) {
                    if (servicecharges[i].id === servicecharge.id) {
                        this.state.servicecharge.value = JSON.stringify(servicecharges[i]);
                    }
                }
            }
            this.state.servicecharge.options = servicecharges;
            this.setState({servicecharge: this.state.servicecharge});
        },
    };

    functions = {
        setTab: (value, error) => {
            this.state.tabs.value = value;
            this.state.price.value = 0;
            this.setState({tabs: this.state.tabs, price: this.state.price});
        },
        setProperty: (value, error) => {
            this.state.property.value = value;
            this.state.property.error = error;
            this.setState({tabs: this.state.property});
        },
        setCurrency: (value, error) => {
            this.state.currencies.value = value;
            this.state.currencies.error = error;
            this.setState({currencies: this.state.currencies});
        },
        setType: (value, error) => {
            this.state.types.value = value;
            this.state.types.error = error;
            this.setState({types: this.state.types});
        },
        setBed: (value, error) => {
            this.state.beds.value = value;
            this.state.beds.error = error;
            this.setState({beds: this.state.beds});
        },
        setBath: (value, error) => {
            this.state.baths.value = value;
            this.state.baths.error = error;
            this.setState({baths: this.state.baths});
        },
        setStatus: (value, error) => {
            this.state.stats.value = value;
            this.state.stats.error = error;
            this.setState({stats: this.state.stats});
        },
        setFurnishing: (value, error) => {
            this.state.furnishings.value = value;
            this.state.furnishings.error = error;
            this.setState({furnishings: this.state.furnishings});
        },
        setGoogle: (value, error) => {
            this.state.google.value = value;
            this.state.google.error = error;
            this.setState({google: this.state.google});
        },
        setRegion: (value, grid, circle) => {
            if(value.level !== 4){
                this.state.region.value = value;
            }else if(circle){
                this.state.region.value = value;
            }
            this.state.region.grid = grid;
            this.setState({region: this.state.region}, () => {
                try{
                    this.setState({
                        country: JSON.parse(grid[1].value).country_code
                    }, () => {
                        console.log(this.state.country);
                    })
                }catch (e) {}
            });
        },
        setSize: (value) => {
            this.state.size.value = value;
            this.setState({size: this.state.size});
        },
        setPrice: (value) => {
            this.state.price.value = value;
            this.setState({price: this.state.price});
        },
        setDuration: (price, duration, error) => {
            this.state.durations.value = duration;
            this.state.durations.error = error;
            this.state.price.value = price;
            this.setState({durations: this.state.durations, price: this.state.price});
        },
        setAmenity: (values) => {
            this.state.amenities.options = values;
            this.setState({amenities: this.state.amenities});
        },
        setDiscount: (value, error) => {
            this.state.discounts.value = value;
            this.state.discounts.error = error;
            this.setState({discounts: this.state.discounts});
        },
        setDldwaiver: (value, error) => {
            this.state.dldwaivers.value = value;
            this.state.dldwaivers.error = error;
            this.setState({dldwaivers: this.state.dldwaivers});
        },
        setCheque: (value, error) => {
            this.state.cheques.value = value;
            this.state.cheques.error = error;
            this.setState({cheques: this.state.cheques});
        },
        setFreemonth: (value, error) => {
            this.state.freemonths.value = value;
            this.state.freemonths.error = error;
            this.setState({freemonths: this.state.freemonths});
        },
        setDownpayment: (value, error) => {
            this.state.downpayments.value = value;
            this.state.downpayments.error = error;
            this.setState({downpayments: this.state.downpayments});
        },
        setFinance: (value, error) => {
            this.state.finance.value = value;
            this.state.finance.error = error;
            this.setState({finance: this.state.finance});
        },
        setRoi: (value, error) => {
            this.state.roi.value = value;
            this.state.roi.error = error;
            this.setState({roi: this.state.roi});
        },
        setPaymentplan: (value, error) => {
            this.state.paymentplan.value = value;
            this.state.paymentplan.error = error;
            this.setState({paymentplan: this.state.paymentplan});
        },
        setServicecharge: (value, error) => {
            this.state.servicecharge.value = value;
            this.state.servicecharge.error = error;
            this.setState({servicecharge: this.state.servicecharge});
        },
        next: () => {

            //CHECK IF ALL DATA EXIST
            this.state.types.error = !this.state.types.value || this.state.types.value === "-1";
            this.state.beds.error = !this.state.beds.value || this.state.beds.value === "-1";
            this.state.baths.error = !this.state.baths.value || this.state.baths.value === "-1";
            this.state.google.error = !this.state.google.value;
            this.state.region.error = !this.state.region.value;

            //TABS SPECIFIC
            if(this.state.tabs.value.id === 1){
                this.state.durations.error = !this.state.durations.value || this.state.durations.value === "-1";
                this.state.furnishings.error = !this.state.furnishings.value || this.state.furnishings.value === "-1";
            }else if(this.state.tabs.value.id === 0){
                this.state.stats.error = !this.state.stats.value || this.state.stats.value === "-1";
            }

            //REGIONS DROPDOWN NARROW ERRORS
            console.log(this.state.region.grid);
            this.state.regions_errors = {};
            if(!this.state.region.grid || (this.state.region.grid && this.state.region.grid["4"] && this.state.region.grid["4"].value == '-1')){
                this.state.regions_errors["4"] = true;
                this.setState({
                    regions_errors: this.state.regions_errors
                });
            }else if(!this.state.region.grid || (this.state.region.grid && this.state.region.grid["3"] && this.state.region.grid["3"].value == '-1')){
                this.state.regions_errors["3"] = true;
                this.setState({
                    regions_errors: this.state.regions_errors
                });
            }else if(!this.state.region.grid || (this.state.region.grid && this.state.region.grid["2"] && this.state.region.grid["2"].value == '-1')){
                this.state.regions_errors["2"] = true;
                this.setState({
                    regions_errors: this.state.regions_errors
                });
            }else if(!this.state.region.grid || (this.state.region.grid && this.state.region.grid["1"] && this.state.region.grid["1"].value == '-1')){
                this.state.regions_errors["1"] = true;
                this.setState({
                    regions_errors: this.state.regions_errors
                });
            }

            this.setState({
                types: this.state.types,
                beds: this.state.beds,
                baths: this.state.baths,
                stats: this.state.stats,
                google: this.state.google,
                durations: this.state.durations,
                furnishings: this.state.furnishings,
                error: false
            }, () => {

                let regions_errors = false;
                for(let key in this.state.regions_errors){
                    if(this.state.regions_errors[key]){
                        regions_errors = true;
                    }
                }

                if(!regions_errors && !this.state.region.error && !this.state.furnishings.error && !this.state.durations.error && !this.state.types.error && !this.state.beds.error && !this.state.baths.error && !this.state.stats.error && !this.state.google.error){

                    //SET DESCRIPTION
                    if(this.state.description){
                        collectedRegister.setValue("description", this.state.description);
                    }

                    //SET DRAFT ID
                    if(this.state.draft){
                        collectedRegister.setValue("draft", this.state.draft);
                    }

                    //SET WEB TOUR
                    if(this.state.web_tour){
                        collectedRegister.setValue("web_tour", this.state.web_tour);
                    }

                    collectedRegister.setValue("website", this.state.website);
                    collectedRegister.setValue("platform", this.state.platform);
                    collectedRegister.setValue("listing_type", this.state.tabs.value);
                    collectedRegister.setValue("currency", this.state.currencies.value);
                    collectedRegister.setValue("base_currency", this.state.price.currency);
                    collectedRegister.setValue("type", this.state.types.value);
                    collectedRegister.setValue("bed", this.state.beds.value);
                    collectedRegister.setValue("bath", this.state.baths.value);
                    collectedRegister.setValue("status", this.state.stats.value);
                    collectedRegister.setValue("google", this.state.google.value);
                    collectedRegister.setValue("places", this.state.region.places);
                    collectedRegister.setValue("region", this.state.region.value);
                    collectedRegister.setValue("region_grid", this.state.region.grid);
                    collectedRegister.setValue("display_region", this.state.region.value);
                    collectedRegister.setValue("size", this.state.size.value);
                    collectedRegister.setValue("price", this.state.price.value);
                    collectedRegister.setValue("duration", this.state.durations.value);
                    collectedRegister.setValue("amenities", this.state.amenities.options);
                    collectedRegister.setValue("amenities_revert", this.state.amenities.options);
                    collectedRegister.setValue("images", this.state.images);
                    collectedRegister.setValue("discount", this.state.discounts.value);
                    collectedRegister.setValue("dldwaiver", this.state.dldwaivers.value);
                    collectedRegister.setValue("furnishings", this.state.furnishings.value);
                    collectedRegister.setValue("cheques", this.state.cheques.value);
                    collectedRegister.setValue("freemonths", this.state.freemonths.value);
                    collectedRegister.setValue("downpayments", this.state.downpayments.value);
                    collectedRegister.setValue("finance", this.state.finance.value);
                    collectedRegister.setValue("roi", this.state.roi.value);
                    collectedRegister.setValue("paymentplan", this.state.paymentplan.value);
                    collectedRegister.setValue("servicecharge", this.state.servicecharge.value);
                    collectedRegister.setValue("contact", this.state.contact);
                    collectedRegister.setValue("qrcode_ads", this.state.qrcode_ads);

                    //SET VALUES CUSTOM CREATIVE
                    collectedRegister.setValue("custom_creative", this.state.custom_creative);
                    try{
                        if (this.state.reseller_name !== ""){
                            collectedRegister.setValue("reseller_name", this.state.reseller_name.toLowerCase().split(' ').join('_'));
                        }
                    }catch (e) {
                        console.log(e);
                    }
                    try{
                    collectedRegister.setValue("offering", "for " + this.state.tabs.value.indentifier);
                    }catch (e) {
                        console.log(e);
                    }
                    try{
                        collectedRegister.setValue("size_custom", this.renders.number(this.state.size.value) + " sq. ft.");
                        //collectedRegister.setValue("size_custom", this.renders.sqm(this.state.size.value) + " m²");
                    }catch (e) {
                        console.log(e);
                    }


                    scraperRegister.remove();

                    //IMAGE STEP
                    let image_tags = [
                        {id: 0, title: "Bedroom"},
                        {id: 1, title: "Kitchen"},
                        {id: 2, title: "Balcony"},
                        {id: 3, title: "Bathroom"},
                        {id: 4, title: "Pool"},
                        {id: 5, title: "Gym"},
                        {id: 6, title: "Living Room"},
                        {id: 7, title: "Garden"},
                        // NEW ONES START HERE
                        {id: 8, title: "Terrace"},
                        {id: 9, title: "Hallway"},
                        {id: 10, title: "Home Cinema"},
                        {id: 11, title: "Walk-in Closet"},
                        {id: 12, title: "Hot Tub"},
                        {id: 13, title: "Fireplace"},
                        {id: 14, title: "Home Office"},
                        {id: 15, title: "Beach Access"},
                        {id: 16, title: "Dining Area"},
                        {id: 17, title: "Golf Access"},
                        {id: 18, title: "Game Room"},
                        {id: 19, title: "Spa"},
                        {id: 20, title: "Floor Plan"},
                    ];
                    let image_available_labels = {
                        "bedroom": {id: 0, score: 0.65, title: "Bedroom"},
                        "kitchen": {id: 1, score: 0.50, title: "Kitchen"},
                        "balcony": {id: 2, score: 0.65, title: "Balcony"},
                        "bathroom": {id: 3, score: 0.65, title: "Bathroom"},
                        "reflecting pool": {id: 4, score: 0.65, title: "Pool"},
                        "swimming pool": {id: 4, score: 0.65, title: "Pool"},
                        "gym": {id: 5, score: 0.55, title: "Gym"},
                        "exercise equipment": {id: 5, score: 0.55, title: "Gym"},
                        "exercise machine": {id: 5, score: 0.55, title: "Gym"},
                        "weight training": {id: 5, score: 0.55, title: "Gym"},
                        "weightlifting machine": {id: 5, score: 0.55, title: "Gym"},
                        "crossfit": {id: 5, score: 0.55, title: "Gym"},
                        "living room": {id: 6, score: 0.65, title: "Living Room"},
                        "courtyard": {id: 7, score: 0.60, title: "Garden"},
                        "lawn": {id: 7, score: 0.60, title: "Garden"},
                        "yard": {id: 7, score: 0.60, title: "Garden"},
                        "roof": {id: 2, score: 0.65, title: "Balcony"},
                    };
                    if(this.state.images.length > 0){
                        imagesRegister.set(this.state.images);
                    }
                    flowRegister.setValue("image_tags", image_tags);
                    flowRegister.setValue("image_available_labels", image_available_labels);

                    //SLOGAN STEP
                    let slogan_extras = [
                        "Cosy [Type]",
                        "Stunning [Type]",
                        "Gorgeous [Type]",
                        "Contemporary [Type]",
                        "Beautiful [Type]",
                        "Massive [Type]",
                        "Wonderful [Type]",
                        "Signature [Type]",
                        "Astonishing [Type]",
                        "Impressive [Type]",
                        "Elegant [Type]",
                        "Well Priced [Type]",
                        "Spectacular [Type]",
                        "Peaceful [Type]",
                        "Lavish [Type]",
                        "Exquisite [Type]",
                        "Charming [Type]",
                        "Timeless [Type]",
                        // NEW ONES START HERE
                        "Ideal [Type]",
                        "Comfy [Type]",
                        "Homy [Type]",
                        "Luscious [Type]",
                        "Lovely [Type]",
                        "Grand [Type]",
                        "Tasteful [Type]",
                        "Designer [Type]",
                        "Entertainer's [Type]",
                        "Captivating [Type]",
                        "Featured [Type]",
                        "Exceptional [Type]",
                        "Well Planned [Type]",
                        "Modern [Type]",
                        "Spacious [Type]",
                        "Bright [Type]",
                        "Stylish [Type]",
                        "Magnificent [Type]",
                        "Bespoke [Type]",
                        "Sophisticated [Type]",
                        "Rare [Type]",
                        "Incredible [Type]",
                        "Brand New [Type]",
                        "Exclusive [Type]",
                        "Luxury [Type]",
                        "Affordable [Type]",
                        "Upgraded [Type]"
                    ];
                    for(let i = 0; i < slogan_extras.length; i++){
                        if(JSON.parse(this.state.types.value).id === 1 && JSON.parse(this.state.beds.value).amount === 0){
                            slogan_extras[i] = {detail: "activation", title: slogan_extras[i].replace("[Type]", "Studio")};
                        }else{
                            slogan_extras[i] = {detail: "activation", title: slogan_extras[i].replace("[Type]", JSON.parse(this.state.types.value).title)};
                        }
                    }
                    if(this.state.tabs.value.id === 1){
                        if(this.state.furnishings.value !== "-1"){
                            slogan_extras.push({detail: "validation", title: JSON.parse(this.state.furnishings.value).title});
                        }
                        if(this.state.freemonths.value !== "-1"){
                            slogan_extras.push({detail: "offer", title: JSON.parse(this.state.freemonths.value).title});
                        }
                        if(this.state.cheques.value !== "-1"){
                            slogan_extras.push({detail: "offer", title: JSON.parse(this.state.cheques.value).title});
                        }
                    }
                    if(this.state.tabs.value.id === 0){
                        if(this.state.stats.value !== "-1"){
                            slogan_extras.push({detail: "validation", title: JSON.parse(this.state.stats.value).title});
                        }
                        if(this.state.discounts.value !== "-1"){
                            slogan_extras.push({detail: "offer", title: JSON.parse(this.state.discounts.value).title});
                        }
                        if(this.state.dldwaivers.value !== "-1"){
                            slogan_extras.push({detail: "offer", title: JSON.parse(this.state.dldwaivers.value).title});
                        }
                        if(this.state.downpayments.value !== "-1"){
                            slogan_extras.push({detail: "offer", title: JSON.parse(this.state.downpayments.value).title});
                        }
                        if(this.state.finance.value !== "-1"){
                            slogan_extras.push({detail: "offer", title: JSON.parse(this.state.finance.value).title});
                        }
                        if(this.state.roi.value !== "-1"){
                            slogan_extras.push({detail: "offer", title: JSON.parse(this.state.roi.value).title});
                        }
                        if(this.state.paymentplan.value !== "-1"){
                            slogan_extras.push({detail: "offer", title: JSON.parse(this.state.paymentplan.value).title});
                        }
                        if(this.state.servicecharge.value !== "-1"){
                            slogan_extras.push({detail: "offer", title: JSON.parse(this.state.servicecharge.value).title});
                        }
                    }
                    flowRegister.setValue("slogan_extras", slogan_extras);
                    flowRegister.setValue("slogan_extras_revert", slogan_extras);
                    let slogan_matches = [];
                    for(let i = 0; i < this.state.amenities.options.length; i++){
                        if(this.state.amenities.options[i].selected){
                            slogan_matches.push(this.state.amenities.options[i].title);
                        }
                    }
                    flowRegister.setValue("slogan_matches", slogan_matches);
                    flowRegister.setValue("slogan_matches_revert", slogan_matches);
                    let slogan_excludes = [];
                    if(this.state.tabs.value.id === 1){
                        for(let i = 0; i < this.state.furnishings.options.length; i++){
                            // if(this.state.furnishings.options[i].id !== JSON.parse(this.state.furnishings.value).id){
                            if(this.state.furnishings.options[i].id !== -1){
                                slogan_excludes.push(this.state.furnishings.options[i].title);
                            }
                        }
                    }
                    if(this.state.tabs.value.id === 0){
                        for(let i = 0; i < this.state.stats.options.length; i++){
                            // if(this.state.stats.options[i].id !== JSON.parse(this.state.stats.value).id){
                            if(this.state.stats.options[i].id !== -1){
                                slogan_excludes.push(this.state.stats.options[i].title);
                            }
                        }
                    }
                    flowRegister.setValue("slogan_excludes", slogan_excludes);

                    //flowRegister.setValue("slogan_highlight", JSON.parse(this.state.types.value).title);

                    if(JSON.parse(this.state.types.value).id === 1 && JSON.parse(this.state.beds.value).amount === 0){
                        flowRegister.setValue("slogan_highlight", "Studio");
                    }else{
                        flowRegister.setValue("slogan_highlight", JSON.parse(this.state.types.value).title);
                    }

                    flowRegister.setValue("slogan_type", this.state.tabs.value.id === 0?"sell":"rent");

                    //GET INDUSTRY
                    let type = JSON.parse(this.state.types.value).title;
                    let beds = JSON.parse(this.state.beds.value).title;
                    let string = "";
                    let industry = null;
                    if(type.toLowerCase() === 'apartment'){
                        string = beds + "for";
                    }else{
                        string = type + "for";
                    }
                    string = string + this.state.tabs.value.indentifier;
                    string = string.toLowerCase().trim().replace(/\s/g, '');
                    for (let i = 0; i < this.state.industries.length; i++) {
                        if(this.state.industries[i].name.toLowerCase().trim().replace(/\s/g, '') === string){
                            industry = this.state.industries[i];
                        }
                    }

                    if(industry){
                        cartRegister.setIndustry(industry);

                        flowRegister.setValue("industry_type", this.state.tabs.value.id === 0?"sale":"rent");

                        //FILTER STEP
                        let industries_excludes = [];
                        if(this.state.tabs.value.id === 1){
                            for(let i = 0; i < this.state.furnishings.options.length; i++){
                                if(this.state.furnishings.options[i].id !== JSON.parse(this.state.furnishings.value).id){
                                    industries_excludes.push(this.state.furnishings.options[i].title);
                                }
                            }
                        }
                        if(this.state.tabs.value.id === 0){
                            for(let i = 0; i < this.state.stats.options.length; i++){
                                if(this.state.stats.options[i].id !== JSON.parse(this.state.stats.value).id){
                                    industries_excludes.push(this.state.stats.options[i].title);
                                }
                            }
                        }
                        let industries_mathces = [];
                        if(this.state.tabs.value.id === 1){
                            if(this.state.furnishings.value !== "-1"){
                                industries_mathces.push(JSON.parse(this.state.furnishings.value).title);
                            }
                            if(this.state.cheques.value !== "-1"){
                                industries_mathces.push("multiple cheques");
                            }
                            if(this.state.freemonths.value !== "-1"){
                                industries_mathces.push("free months");
                            }
                        }
                        if(this.state.tabs.value.id === 0){
                            if(this.state.stats.value !== "-1"){
                                industries_mathces.push(JSON.parse(this.state.stats.value).title);
                            }
                            if(this.state.discounts.value !== "-1"){
                                industries_mathces.push("reduced price");
                            }
                            if(this.state.dldwaivers.value !== "-1"){
                                industries_mathces.push("dld waiver");
                            }
                            if(this.state.downpayments.value !== "-1"){
                                industries_mathces.push("small down payment");
                            }
                            if(this.state.finance.value !== "-1"){
                                industries_mathces.push("mortgage deal");
                            }
                            if(this.state.roi.value !== "-1"){
                                industries_mathces.push("investor deal");
                            }
                            if(this.state.paymentplan.value !== "-1"){
                                industries_mathces.push("payment plan");
                            }
                            if(this.state.servicecharge.value !== "-1"){
                                industries_mathces.push("free service charge");
                            }
                        }
                        cartRegister.setSelectedIndustries(null);
                        flowRegister.setValue("industries_excludes", industries_excludes);
                        flowRegister.setValue("industries_mathces", industries_mathces);
                        flowRegister.setValue("industries_mathces_revert", industries_mathces);

                        let autocomplete_address = '';
                        try{
                            autocomplete_address = this.state.google.value.autocomplete_address; //.toLowerCase();
                            const str = autocomplete_address;
                            const arr = str.split(" ");
                            for (var i = 0; i < arr.length; i++) {
                                if(arr[i].replace(/[^A-Z]/g, "").length > 2){

                                }else{
                                    arr[i] = arr[i].toLowerCase();
                                    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
                                }
                                //arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
                            }
                            autocomplete_address = arr.join(" ");
                        }catch (e) {
                            console.log(e);
                            autocomplete_address = this.state.google.value.autocomplete_address;
                        }

                        //ADS DATA TITLE
                        let ads_title = this.state.region.value.name + ", " + autocomplete_address;
                        let ads_title_long = this.state.region.value.name + ", " + autocomplete_address;
                        if(ads_title.length > 24){
                            ads_title.trim();
                            ads_title = ads_title.substr(0, 24);
                            ads_title = ads_title + ".";
                        }

                        let ads_price = (+this.state.price.value > 0?(JSON.parse(this.state.currencies.value).title + " " + this.renders.numberCommas((JSON.parse(this.state.currencies.value).rate * +this.state.price.value))):"Price On Request");
                        if(this.state.tabs.value.id === 1 && this.state.price.value > 0){
                            ads_price = ads_price + " " + JSON.parse(this.state.durations.value).title;
                        }
                        let ads_title_instagram = ads_title + " | " + ads_price;
                        let ads_title_facebook = industry.name + " | " + ads_title + " | " + ads_price;
                        let ads_title_google = industry.name + " | " + ads_title + " | " + ads_price;
                        let ads_title_bing = industry.name + " | " + ads_title + " | " + ads_price;
                        flowRegister.setValue("ads_title_facebook", ads_title_facebook);
                        flowRegister.setValue("ads_title_instagram", ads_title_instagram);
                        flowRegister.setValue("ads_title_google", ads_title_google);
                        flowRegister.setValue("ads_title_bing", ads_title_bing);

                        flowRegister.setValue("ads_title_facebook_original", ads_title_facebook);
                        flowRegister.setValue("ads_title_instagram_original", ads_title_instagram);
                        flowRegister.setValue("ads_title_google_original", ads_title_google);
                        flowRegister.setValue("ads_title_bing_original", ads_title_bing);

                        //REGION LONGTAILS
                        if(this.state.region){
                            let ids = [];
                            //on AE market only send relevant levels to limit keyword combos, other markets send all as default later can be tweaked
                            if (JSON.parse(this.state.region.grid[1].value).id === 4940) {
                                for(let key in this.state.region.grid){
                                        if(this.state.region.grid[key].value !== "-1" && this.state.region.grid[key].value && key !== "2"){
                                            ids.push(JSON.parse(this.state.region.grid[key].value).id);
                                        }
                                }
                            } else {
                                for(let key in this.state.region.grid){
                                    if(this.state.region.grid[key].value !== "-1" && this.state.region.grid[key].value){
                                        ids.push(JSON.parse(this.state.region.grid[key].value).id);
                                    }
                                }
                            }
                            flowRegister.setValue("longtail_regions", ids.join());
                        }

                        //CAMPAIGN DATA
                        if(+this.state.price.value < 1){
                            flowRegister.setValue("company_name", "Price On Request");
                            flowRegister.setValue("company_name_original", "Price On Request");
                        }else{
                            flowRegister.setValue("company_name", ads_price);
                            flowRegister.setValue("company_name_original", ads_price);
                        }
                        flowRegister.setValue("display_region", ads_title);
                        flowRegister.setValue("industry_name", industry.name);

                        //flowRegister.setValue("company_name", ads_price);

                        //EXCEPTION FOR APARTMENTS
                        let industry_title = "";
                        if(type.toLowerCase() === 'apartment'){
                            industry_title = type + " For " + this.renders.capitalize(this.state.tabs.value.indentifier);
                        }else{
                            industry_title = industry.name;
                        }

                        console.log(this.state.region);
                        let theme_region = null;
                        if(this.state.region.grid['4'] && this.state.region.grid['4'].value !== "-1"){
                            let region_value = JSON.parse(this.state.region.grid['4'].value);
                            theme_region = region_value.name;
                        }
                        if(!theme_region && this.state.region.grid['3'] && this.state.region.grid['3'].value !== "-1"){
                            let region_value = JSON.parse(this.state.region.grid['3'].value);
                            theme_region = region_value.name;
                        }
                        if(!theme_region && this.state.region.grid['2'] && this.state.region.grid['2'].value !== "-1"){
                            let region_value = JSON.parse(this.state.region.grid['2'].value);
                            theme_region = region_value.name;
                        }
                        if(!theme_region && this.state.region.grid['1'] && this.state.region.grid['1'].value !== "-1"){
                            let region_value = JSON.parse(this.state.region.grid['1'].value);
                            theme_region = region_value.name;
                        }

                        //THEME
                        let theme_data = {
                            theme_region: theme_region,
                            first_title: industry_title,
                            first_subtitle: ads_title,
                            first_subtitle_long: ads_title_long,
                            first_image: null,
                            first_name: null,
                            last_title: ads_price,
                            last_subtitle: "learn more",
                            last_image: null,
                            center_top: this.state.region.value.name + " • " + JSON.parse(this.state.beds.value).title + " • " + industry_title,
                            center_bottom: ads_price,
                            center_slogan: null,
                            center_images: [],
                            slogan_activation: null,
                            slogan_validation: null,
                            slogan_offer: null,
                            slogan_action: null,
                            contact_name: this.state.contact.name,
                            contact_company_name: this.state.contact.company,
                            contact_image: this.state.contact.profile_image,
                            contact_logo: this.state.contact.logo,
                            //contact_phone: "+971 " + this.state.contact.phone
                        };
                        themeRegister.setValue(theme_data);

                        //LOCATION
                        flowRegister.setValue("google", this.state.google.value);

                        //WEBSITE
                        if(this.state.website){
                            flowRegister.setValue("website", this.state.website);
                        }

                        //PLATFORM
                        if(this.state.platform){
                            flowRegister.setValue("platform", this.state.platform);
                        }

                        //MAIN IMAGE TITLE
                        if(this.state.size){

                            if (JSON.parse(this.state.currencies.value).title.toLowerCase() !== this.state.price.currency.toLowerCase()) {
                                if (this.state.size.value > 10740) {
                                    flowRegister.setValue("main_image_title", this.renders.numberNoSpace(this.state.size.value) + " sqft" + " / " + this.renders.sqmNoSpace(this.state.size.value) + " sqm");
                                } else {
                                    flowRegister.setValue("main_image_title", this.renders.number(this.state.size.value) + " sqft" + " / " + this.renders.sqm(this.state.size.value) + " sqm");
                                }
                            } else {
                                //flowRegister.setValue("main_image_title", this.renders.number(this.state.size.value) + " sqft" + " / " + this.renders.sqm(this.state.size.value) + " sqm");
                                flowRegister.setValue("main_image_title", this.renders.number(this.state.size.value) + " sqft");
                            }

                        }

                        //VIDEO DATA
                        let slides = [];
                        if(this.state.beds.value !== "-1"){
                            slides.push({
                                label: 0,
                                title: JSON.parse(this.state.beds.value).amount>1?JSON.parse(this.state.beds.value).title + "rooms":(JSON.parse(this.state.beds.value).amount===1?JSON.parse(this.state.beds.value).title + "room":JSON.parse(this.state.beds.value).title)
                            });
                        }
                        if(this.state.baths.value !== "-1"){
                            slides.push({
                                label: 3,
                                title: JSON.parse(this.state.baths.value).amount>1?JSON.parse(this.state.baths.value).title + "rooms":JSON.parse(this.state.baths.value).title + "room"
                            });
                        }
                        if(this.state.tabs.value.id === 1){
                            if(this.state.furnishings.value !== "-1"){
                                slides.push({
                                    label: 6,
                                    title: JSON.parse(this.state.furnishings.value).title
                                });
                            }
                            if(this.state.freemonths.value !== "-1"){
                                slides.push({
                                    label: null,
                                    title: JSON.parse(this.state.freemonths.value).title
                                });
                            }
                            if(this.state.cheques.value !== "-1"){
                                slides.push({
                                    label: null,
                                    title: JSON.parse(this.state.cheques.value).title
                                });
                            }
                        }else if(this.state.tabs.value.id === 0){
                            if(this.state.stats.value !== "-1"){
                                slides.push({
                                    label: null,
                                    title: JSON.parse(this.state.stats.value).title
                                });
                            }
                            if(this.state.discounts.value !== "-1"){
                                slides.push({
                                    label: null,
                                    title: JSON.parse(this.state.discounts.value).title
                                });
                            }
                            if(this.state.dldwaivers.value !== "-1"){
                                slides.push({
                                    label: null,
                                    title: JSON.parse(this.state.dldwaivers.value).title
                                });
                            }
                            if(this.state.downpayments.value !== "-1"){
                                slides.push({
                                    label: null,
                                    title: JSON.parse(this.state.downpayments.value).title
                                });
                            }
                            if(this.state.finance.value !== "-1"){
                                slides.push({
                                    label: null,
                                    title: JSON.parse(this.state.finance.value).title
                                });
                            }
                            if(this.state.roi.value !== "-1"){
                                slides.push({
                                    label: null,
                                    title: JSON.parse(this.state.roi.value).title
                                });
                            }
                            if(this.state.paymentplan.value !== "-1"){
                                slides.push({
                                    label: null,
                                    title: JSON.parse(this.state.paymentplan.value).title
                                });
                            }
                            if(this.state.servicecharge.value !== "-1"){
                                slides.push({
                                    label: null,
                                    title: JSON.parse(this.state.servicecharge.value).title
                                });
                            }
                        }
                        flowRegister.setValue("video_items", slides);

                        console.log(scraperRegister.getImagesAvailableBoolean());

                        if(this.state.inhouse && scraperRegister.getImagesAvailableBoolean() && scraperRegister.getImagesAvailableBoolean() !== "false"){
                            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/images?creative=manual");
                        }else{
                            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/images");
                        }

                    }else{
                        this.setState({
                            error: true
                        });
                    }

                }else{
                    this.setState({
                        error: true
                    })
                }

            });
        },
        back: () => {
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/options");
        }
    };

    renders = {
        text: (item) => {
            return langRegister.get("booster-industry", item);
        },
        number: (number) => {
            try {
                number = Math.round(number);
                return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            } catch (e) {
                return ("...")
            }
        },
        numberCommas: (number) => {
            try {
                number = Math.round(number);
                return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } catch (e) {
                return ("...")
            }
        },
        numberNoSpace: (number) => {
            try {
                number = Math.round(number);
                return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "");
            } catch (e) {
                return ("...")
            }
        },
        sqm: (value) => {
            return this.renders.number(Math.round(value * 0.093));
        },
        sqmNoSpace: (value) => {
            return this.renders.numberNoSpace(Math.round(value * 0.093));
        },
        capitalize: (word) => {
        let lower = word.toLowerCase();
        return word.charAt(0).toUpperCase() + lower.slice(1);
        },
    };

    render() {
        return (
            <div>
                <BoosterHeader props={this.props}/>
                {
                    !this.state.isLoading &&
                    <div className={Styles.container}>
                        <div className={Styles.title}>
                            <div>
                                {this.renders.text("item_1")}
                            </div>
                        </div>
                        <div className={Styles.optionsContainer}>
                            {
                                <DropdownTabs
                                    options={this.state.tabs.options}
                                    disabled={this.state.tabs.disabled}
                                    error={this.state.tabs.error}
                                    value={this.state.tabs.value}
                                    onChange={this.functions.setTab}
                                />
                            }
                            {
                                <div className={Styles.optionsContainerSection}>
                                    <Dropdown
                                        options={this.state.property.options}
                                        disabled={this.state.property.disabled}
                                        error={this.state.property.error}
                                        placeholder={this.state.property.placeholder}
                                        value={this.state.property.value}
                                        onChange={this.functions.setProperty}
                                    />
                                    <Dropdown
                                        options={this.state.types.options}
                                        disabled={this.state.types.disabled}
                                        error={this.state.types.error}
                                        placeholder={this.state.types.placeholder}
                                        value={this.state.types.value}
                                        onChange={this.functions.setType}
                                    />
                                    <Dropdown
                                        options={this.state.beds.options}
                                        disabled={this.state.beds.disabled}
                                        error={this.state.beds.error}
                                        placeholder={this.state.beds.placeholder}
                                        value={this.state.beds.value}
                                        onChange={this.functions.setBed}
                                    />
                                    <Dropdown
                                        options={this.state.baths.options}
                                        disabled={this.state.baths.disabled}
                                        error={this.state.baths.error}
                                        placeholder={this.state.baths.placeholder}
                                        value={this.state.baths.value}
                                        onChange={this.functions.setBath}
                                    />
                                    {
                                        this.state.tabs.value.id === 1 &&
                                        <Dropdown
                                            options={this.state.furnishings.options}
                                            disabled={this.state.furnishings.disabled}
                                            error={this.state.furnishings.error}
                                            placeholder={this.state.furnishings.placeholder}
                                            value={this.state.furnishings.value}
                                            onChange={this.functions.setFurnishing}
                                        />
                                    }
                                    {
                                        this.state.tabs.value.id === 0 &&
                                        <Dropdown
                                            options={this.state.stats.options}
                                            disabled={this.state.stats.disabled}
                                            error={this.state.stats.error}
                                            placeholder={this.state.stats.placeholder}
                                            value={this.state.stats.value}
                                            onChange={this.functions.setStatus}
                                        />
                                    }
                                </div>
                            }
                            {
                                <div className={Styles.optionsContainerSection}>
                                    <div className={Styles.optionsContainerSectionTitle}>
                                        Size
                                    </div>
                                    <DropdownSliderSize
                                        caption_sqft={this.state.size.caption_sqft}
                                        caption_sqm={this.state.size.caption_sqm}
                                        disabled={this.state.size.disabled}
                                        error={this.state.size.error}
                                        value={this.state.size.value}
                                        onChange={this.functions.setSize}
                                    />
                                </div>
                            }
                            {
                                this.state.tabs.value.id === 0 &&
                                <div className={Styles.optionsContainerSection}>
                                    <div className={Styles.optionsContainerSectionTitle}>
                                        Price
                                    </div>
                                    <DropdownSliderPrice
                                        caption={this.state.price.caption}
                                        disabled={this.state.price.disabled}
                                        error={this.state.price.error}
                                        currency={this.state.price.currency}
                                        value={this.state.price.value}
                                        onChange={this.functions.setPrice}
                                    />
                                </div>
                            }
                            {
                                this.state.tabs.value.id === 1 &&
                                <div className={Styles.optionsContainerSection}>
                                    <div className={Styles.optionsContainerSectionTitle}>
                                        Price
                                    </div>
                                    <DropdownSliderDuration
                                        caption={this.state.durations.caption}
                                        options={this.state.durations.options}
                                        disabled={this.state.durations.disabled}
                                        error={this.state.durations.error}
                                        value={this.state.durations.value}
                                        price={this.state.price.value}
                                        currency={this.state.price.currency}
                                        onChange={this.functions.setDuration}
                                    />
                                </div>
                            }
                            {
                                <div className={Styles.optionsContainerSection}>
                                    <div className={Styles.optionsContainerSectionTitle}>
                                        Display this currency in my ads
                                    </div>
                                    <DropdownCurrency
                                        options={this.state.currencies.options}
                                        disabled={this.state.currencies.disabled}
                                        error={this.state.currencies.error}
                                        placeholder={this.state.currencies.placeholder}
                                        value={this.state.currencies.value}
                                        price={this.state.price.value}
                                        onChange={this.functions.setCurrency}
                                    />
                                </div>
                            }
                            {
                                <div className={Styles.optionsContainerSection}>
                                    <div className={Styles.optionsContainerSectionTitle}>
                                        Display this address in my ads
                                    </div>
                                    <DropdownGoogle
                                        value={this.state.google.value}
                                        places={this.state.region.places}
                                        error={this.state.google.error}
                                        placeholder={this.state.google.placeholder}
                                        onChange={this.functions.setGoogle}
                                        inhouse={this.state.inhouse}
                                        country={this.state.country}
                                    />
                                </div>
                            }
                            {
                                <div className={Styles.optionsContainerSection}>
                                    <div className={Styles.optionsContainerSectionTitle}>
                                        Display this region in my ads
                                    </div>
                                    <DropdownRegionNarrow
                                        grid={this.state.region.grid}
                                        places={this.state.region.places}
                                        value={this.state.region.value}
                                        error={this.state.region.error}
                                        onChange={this.functions.setRegion}
                                        inhouse={this.state.inhouse}
                                        errors={this.state.regions_errors}
                                    />
                                </div>
                            }
                            {
                                <div className={Styles.optionsContainerSection}>
                                    <div className={Styles.optionsContainerSectionTitle}>
                                        Amenities
                                    </div>
                                    <DropdownAmenities
                                        options={this.state.amenities.options}
                                        onChange={this.functions.setAmenity}
                                    />
                                </div>
                            }
                            <div className={Styles.optionsContainerSection}>
                                <div className={Styles.optionsContainerSectionTitle}>
                                    Extras
                                </div>
                                {
                                    this.state.tabs.value.id === 0 &&
                                    <Dropdown
                                        options={this.state.discounts.options}
                                        disabled={this.state.discounts.disabled}
                                        error={this.state.discounts.error}
                                        placeholder={this.state.discounts.placeholder}
                                        value={this.state.discounts.value}
                                        onChange={this.functions.setDiscount}
                                    />
                                }
                                {
                                    this.state.tabs.value.id === 0 &&
                                    <Dropdown
                                        options={this.state.dldwaivers.options}
                                        disabled={this.state.dldwaivers.disabled}
                                        error={this.state.dldwaivers.error}
                                        placeholder={this.state.dldwaivers.placeholder}
                                        value={this.state.dldwaivers.value}
                                        onChange={this.functions.setDldwaiver}
                                    />
                                }
                                {
                                    this.state.tabs.value.id === 0 &&
                                    <Dropdown
                                        options={this.state.downpayments.options}
                                        disabled={this.state.downpayments.disabled}
                                        error={this.state.downpayments.error}
                                        placeholder={this.state.downpayments.placeholder}
                                        value={this.state.downpayments.value}
                                        onChange={this.functions.setDownpayment}
                                    />
                                }
                                {
                                    /*
                                    this.state.tabs.value.id === 0 &&
                                    <Dropdown
                                        options={this.state.finance.options}
                                        disabled={this.state.finance.disabled}
                                        error={this.state.finance.error}
                                        placeholder={this.state.finance.placeholder}
                                        value={this.state.finance.value}
                                        onChange={this.functions.setFinance}
                                    />
                                    /*/
                                }
                                {
                                    /*
                                    this.state.tabs.value.id === 0 &&
                                    <Dropdown
                                        options={this.state.roi.options}
                                        disabled={this.state.roi.disabled}
                                        error={this.state.roi.error}
                                        placeholder={this.state.roi.placeholder}
                                        value={this.state.roi.value}
                                        onChange={this.functions.setRoi}
                                    />
                                    /*/
                                }
                                {
                                    this.state.tabs.value.id === 0 &&
                                    <Dropdown
                                        options={this.state.paymentplan.options}
                                        disabled={this.state.paymentplan.disabled}
                                        error={this.state.paymentplan.error}
                                        placeholder={this.state.paymentplan.placeholder}
                                        value={this.state.paymentplan.value}
                                        onChange={this.functions.setPaymentplan}
                                    />
                                }
                                {
                                    this.state.tabs.value.id === 0 &&
                                    <Dropdown
                                        options={this.state.servicecharge.options}
                                        disabled={this.state.servicecharge.disabled}
                                        error={this.state.servicecharge.error}
                                        placeholder={this.state.servicecharge.placeholder}
                                        value={this.state.servicecharge.value}
                                        onChange={this.functions.setServicecharge}
                                    />
                                }
                                {
                                    this.state.tabs.value.id === 1 &&
                                    <Dropdown
                                        options={this.state.cheques.options}
                                        disabled={this.state.cheques.disabled}
                                        error={this.state.cheques.error}
                                        placeholder={this.state.cheques.placeholder}
                                        value={this.state.cheques.value}
                                        onChange={this.functions.setCheque}
                                    />
                                }
                                {
                                    this.state.tabs.value.id === 1 &&
                                    <Dropdown
                                        options={this.state.freemonths.options}
                                        disabled={this.state.freemonths.disabled}
                                        error={this.state.freemonths.error}
                                        placeholder={this.state.freemonths.placeholder}
                                        value={this.state.freemonths.value}
                                        onChange={this.functions.setFreemonth}
                                    />
                                }
                            </div>
                            <div className={Styles.buttonContainer}>
                                <div onClick={() => this.functions.next()} className={cx(Styles.button)}>
                                    {
                                        this.state.error &&
                                        <div className={Styles.buttonError}>
                                            {this.renders.text("item_7")}
                                        </div>
                                    }
                                    {this.renders.text("item_8")}
                                </div>
                                {
                                    <div onClick={() => this.functions.back()} className={Styles.backButton}>
                                        {this.renders.text("item_9")}
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                }
                {
                    this.state.isLoading &&
                    <div className={Styles.loader}>
                        <BeatLoader size={30} color={'var(--first-color)'} loading={true}/>
                    </div>
                }
            </div>
        );
    }
}

export default BoosterIndustryPropertyBooster;


// WEBPACK FOOTER //
// ./src/pages/booster-industry-pages/propertybooster/component.js